export default "__VITE_ASSET__j9wMR2x$__"